import { useState, useEffect } from 'react';
import { isCompactNavWidth, isMobileViewportWidth } from '../utils/breakpoints';

// Viewport width + "phone size" flag (utils/breakpoints: width < 768) +
// "compact navigation" flag (width < 1200 — header / side menu / agent banner
// only, see isCompactNavWidth). Width only — no device / OS detection — so
// narrowing a desktop window switches to the phone UI too. All values are
// correct on the first render (not 0 until an effect runs), so components
// never flash the wrong layout.
export default function useScreenWidth() {
  const isWindow = typeof window !== 'undefined';
  const [windowWidth, setWindowWidth] = useState<number>(() =>
    isWindow ? window.innerWidth : 0
  );
  const [isMobileWidth, setIsMobileWidth] = useState(() =>
    isWindow ? isMobileViewportWidth(window.innerWidth) : false
  );
  const [isCompactNav, setIsCompactNav] = useState(() =>
    isWindow ? isCompactNavWidth(window.innerWidth) : false
  );

  useEffect(() => {
    if (!isWindow) return;
    const update = () => {
      const width = window.innerWidth;
      setWindowWidth(width);
      setIsMobileWidth(isMobileViewportWidth(width));
      setIsCompactNav(isCompactNavWidth(width));
    };
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, [isWindow]);

  return { windowWidth, isMobileWidth, isCompactNav };
}
